import * as React from "react"
import HorizontalTagsListView from "../HorizontalTagsListView";
import TypeAhead, { TypeAheadElement } from "../TypeAhead";
import {isEmpty as _isEmpty} from "lodash"
import IDishCatalogueResponse from "../../models/maverick/IDishCatalogueResponse";
import {IDietRecallFoodOption, IDietRecallFoodOptionValue} from "../../models/IDietRecallMealItem";
import DishAdder from "../DishAdder";

/**
 * Created by aditya on 28/06/18.
 */

export interface FoodOptionsItemEditorProps {
    consultationType?: string,
    item: IDietRecallFoodOption[];
    onDataChange: (update: any) => any,
    fetchStaticDishes: (input: string) => Promise<IDishCatalogueResponse[]>
}

export interface FoodOptionsItemEditorState {
    foodDislikeName: string;
}

class FoodOptionsItemEditor extends React.Component<FoodOptionsItemEditorProps, FoodOptionsItemEditorState> {
    constructor(props: FoodOptionsItemEditorProps) {
        super(props);
        this.state = {
            foodDislikeName: ""
        }
    }

    onTagRemove = (index: number) => {
        let updatedFoodDislikes = [...this.props.item];
        updatedFoodDislikes.splice(index, 1);
        this.props.onDataChange(updatedFoodDislikes);
    }

    addDish = (dish: IDietRecallFoodOptionValue) => {
        let updatedDishes = [ ...this.props.item, {value: dish, comment: ""} ];
        this.props.onDataChange(updatedDishes)
    }

    generateDishTags = () => {
        let tags = !_isEmpty(this.props.item) ? this.props.item.map(item => {return `${item.value.name} ${item.value.count !== null && !_isEmpty(item.value.consumptionUnit) && !_isEmpty(item.value.consumptionUnit.unit) ? `- ${item.value.count} ${item.value.consumptionUnit.unit}` : "" }` }) : [];
        // let tags = !_isEmpty(this.props.item) ? this.props.item.map(item => {return `${item.value.name} ${item.value.count !== null && !_isEmpty(item.value.unit) ? `- ${item.value.count} ${item.value.unit}` : "" }` }) : [];
        return tags;
    }

    render() {
        return (
            <div className="food-options-item-editor" >
                <div className="diet-theme-item-editor-name">
                    <div className={"food-options-tags-container"}><HorizontalTagsListView tagsStringArray={this.generateDishTags()} onTagRemove={this.onTagRemove}/></div>
                    <DishAdder onDishAdd={this.addDish} fetchStaticDishes={this.props.fetchStaticDishes}/>
                    {/* <div className={"food-options-input-container"}>
                        <TypeAhead widgetName={"FoodOptionsItem"} name={"food-dislikes"} value={this.state.foodDislikeName} placeholder={"Start typing dish name"} onTypeAheadChange={this.handleFoodDislikeTypeAheadChange} onTypeAheadSelect={this.handleFoodDislikeTypeAheadSelect}/>
                    </div> */}
                </div>
            </div>
        )
    }
}

export default FoodOptionsItemEditor;
